<header class="header d-flex justify-content-between">
  <plys-shop-logo></plys-shop-logo>
  <ng-container *ngIf="themeSet">
    <plys-timer [time]="time$ | async" [expired]="expiredError$ | async"></plys-timer>
  </ng-container>
</header>

<!-- `seatSelectionType$` stays first: its subscription is what keeps the step flow in sync, and a
     later condition short-circuiting it would silence that. -->
<main
  class="main"
  *ngIf="
    (seatSelectionType$ | async) !== null && checkoutReady && (stateService.reinitializing$ | async) === false;
    else loading
  "
>
  <router-outlet></router-outlet>
</main>

<ng-template #loading>
  <main class="main flex-column flex-md-row">
    <div class="order-1 col-12 offset-md-1 col-md-7">
      <div class="card ghost-element" style="height: 400px"></div>
    </div>
    <div class="d-none d-md-block order-0 col-12 order-md-1 col-md-3">
      <div class="ghost-element"></div>
    </div>
  </main>
</ng-template>
<!-- Empty until the staging-only debugger chunk lands; `ngComponentOutlet` renders nothing for null. -->
<ng-container *ngComponentOutlet="stateDebugger"></ng-container>
